var map = {
	"./arrow-next.svg": 215,
	"./arrow-previous.svg": 216,
	"./arrow.svg": 217,
	"./article.svg": 218,
	"./breadcrumbs-bullet.svg": 219,
	"./check.svg": 220,
	"./chevron-down.svg": 221,
	"./close-tag.svg": 222,
	"./close.svg": 223,
	"./controls.svg": 224,
	"./download.svg": 225,
	"./external-link.svg": 226,
	"./form-status/form-error.svg": 227,
	"./form-status/form-redirect.svg": 228,
	"./form-status/form-success.svg": 229,
	"./globe.svg": 230,
	"./info.svg": 231,
	"./infomaniak.svg": 232,
	"./insider.svg": 233,
	"./lock.svg": 234,
	"./logo/logo-cafe.svg": 235,
	"./logo/logo-mjaf.svg": 236,
	"./logo/logo-mjf.svg": 237,
	"./logo/logo-superhuit.svg": 238,
	"./menu-back.svg": 239,
	"./menu-close.svg": 240,
	"./menu.svg": 241,
	"./micro.svg": 242,
	"./more.svg": 243,
	"./note.svg": 244,
	"./play.svg": 245,
	"./plectrum.svg": 246,
	"./prohibited.svg": 247,
	"./search.svg": 248,
	"./social/facebook.svg": 249,
	"./social/instagram.svg": 250,
	"./social/linkedin.svg": 251,
	"./social/tiktok.svg": 252,
	"./social/twitter.svg": 253,
	"./social/youtube.svg": 254,
	"./sun.svg": 255,
	"./superhuit.svg": 256,
	"./swisstopevents.svg": 257,
	"./wave.svg": 258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;